import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-sms',
  templateUrl: './dialog-sms.component.html',
  styleUrls: ['./dialog-sms.component.scss']
})
export class DialogSmsComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<DialogSmsComponent>) { }

  ngOnInit(): void {
  }

  onOtpChange(event:string) {
    if(event.length == 6){
       this.dialogRef.close(event)
    }

  }

  onComplete(){

  }

}
